<div class="forgot-password">
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
        <div class="row" *ngIf="hasError">
            <div class="col-xs-12 col-md-6 offset-md-3 mt-5 alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Oh no!</strong> Looks like you've entered the wrong username or password. Please try again.
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-xs-12 col-md-6 offset-md-3">
                <label for="exampleFormControlInput1" class="form-label mb-3">Enter your email</label>
                <input type="email" class="form-control" id="email" placeholder="Email" formControlName="email" required>
            </div>
        </div>
        
        <div class="row mt-3">
            <div class="col-xs-12 col-md-6 offset-md-3 d-grid">
                <button type="submit" class="btn btn-primary btn-lg login-btn" [disabled]="passwordForm.invalid">Continue</button>
            </div>
        </div>
    </form>
</div>

